<div class="text-center m-4" >
  <div class="text-center">
    <img src="/assets/images/b_400_400.png">
  </div>

  <button class="btn btn-primary" (click)="downloadFreeWorkBook()">
    <i *ngIf="!downloading " class='fa fa-file-pdf-o'></i>
    <span *ngIf="downloading" class="spinner-border spinner-border-lg me-1 text-info"></span>
    Your Free Workbook</button>
    <div class="text-center alert alert-info mt-2">
      <h4>
        Free Lifetime Access to 50% of  Material
      </h4>
      Subscribe to get more worksheets with  solutions, track performance with diagnostic analysis for areas of improvement
    </div>
</div>

